import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // { id, name, role, login }
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // Вошёл по временному паролю (или по паролю слабее правил) — пока не задаст свой,
  // вместо рабочего стола экран смены пароля; сервер это тоже держит (403)
  const [mustChangePassword, setMustChangePassword] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('staff_token');
    if (token) {
      try {
        const data = await api.checkAuth();
        setUser(data);
        if (data.must_change_password) {
          setMustChangePassword(true);
        } else {
          setIsAuthenticated(true);
        }
      } catch {
        localStorage.removeItem('staff_token');
        api.clearToken();
      }
    }
    setIsLoading(false);
  };

  const login = useCallback(async (loginStr, password) => {
    const data = await api.login(loginStr, password);
    setUser({ id: data.employee_id, name: data.name, role: data.role, login: loginStr });
    if (data.must_change_password) {
      setMustChangePassword(true);
    } else {
      setIsAuthenticated(true);
    }
    return data;
  }, []);

  const changePassword = useCallback(async (newPassword, currentPassword = null) => {
    const data = await api.changePassword(newPassword, currentPassword);
    setMustChangePassword(false);
    setIsAuthenticated(true);
    return data;
  }, []);

  const logout = useCallback(() => {
    api.clearToken();
    setUser(null);
    setIsAuthenticated(false);
    setMustChangePassword(false);
  }, []);

  const hasRole = useCallback((role) => {
    return user?.role === role;
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, isLoading, mustChangePassword, login, changePassword, logout, hasRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
